<div class="outer-container">
  <div fxLayout="row" fxLayoutAlign="space-around">
      <div
          class="student-container"
          fxLayout="row"
          fxLayout.lt-sm="column"
      >
          <div class="circle-w-initial">
              <span class="circle-text">
                  {{ studentID }}
              </span>
          </div>
          <div class="border info-container" fxLayout="column" fxLayoutAlign="space-around">
              <div class="name">
                  {{ studentName }}
              </div>
              <div>
                  {{ className }}
              </div>
              <div class="underNameLinks">
                <a href="{{student?.ClassDetails.ClassHomePageUrl}}"><button class="outline-btn-dbl btn-white" >Classroom Homepage</button></a>
                <button class="outline-btn-dbl btn-white" routerLink="/ELearning/Class/{{classID}}">Gradebook</button>
                <button class="outline-btn-dbl btn-white"  *ngIf="showCreateAssignments" (click)="redirectToAssignedClass()">Add New Assignment</button>
                </div>
          </div>
          <div class="info-container cont-r" fxLayout="column" fxLayoutAlign="space-between">
              <div class="assignment-count">
                  Assignment Count&nbsp;:
                  <span *ngIf="studentDataReceived" >
                    {{ assignments ? assignments.length : 0 }}
                  </span>
              </div>

              <button class="outline-btn btn-white" *ngIf="assignments" (click)="onReleaseAll()">
                  Release All
              </button>

              <button class="outline-btn btn-white" *ngIf="assignments" (click)="onUnassignAll()">
                Unassign All
            </button>
          </div>
      </div>
  </div>

  <div fxLayout="row" fxLayout.lt-sm="column" fxLayoutAlign="space-between center" class="student-row">
    <div class="sub-title">
      Assignments
        </div>

        <div class="form-field">
            <mat-form-field appearance="outline">
                <mat-label >Select Class</mat-label>
                <input  type="text" placeholder="Ex. Mathematics" matInput [formControl]="classControl" [matAutocomplete]="class">
                <mat-autocomplete #class="matAutocomplete" (optionSelected)="classChanged($event.option.id)">
                    <mat-option *ngFor="let class of filteredClass | async" [value]="class.ClassName" [id]="class.HBClassID">
                        {{ class.ClassName }}
                    </mat-option>
                </mat-autocomplete>
                <span mat-icon-button matSuffix (click)="clearClassValue()">
                    <mat-icon class="clear-icon">{{ classControl.value?.length ? 'highlight_off': ''}}</mat-icon>
                </span>
            </mat-form-field>
        </div>

    <div fxLayout="row" *ngIf="assignments">
      <!-- <mat-icon class="pr-10 icons border-right">
        search
            </mat-icon> -->
            <div>
                <span>(</span>
                <span>
                    {{ studentDataReceived ? filteredAssignments?.length : '--'}}
                </span>
                <span>
                    / {{ studentDataReceived ? assignments?.length : '--' }}
                </span>
                <span>)</span>
            </div>
            <app-filter class="filter-component" [route]="'student'"></app-filter>
    </div>
  </div>

  <div *ngIf="!studentDataReceived" class="spinner-wrapper">
    <mat-spinner [diameter]="50" mode="indeterminate"></mat-spinner>
  </div>

  <div *ngIf="studentDataReceived">
    <div class="no-data-container" *ngIf="assignments && !filteredAssignments?.length">
        <div class="heading">
            We couldn't find any Assignments matching the current Filtering options.
        </div>
        <div class="sub-heading">
            Change the Filter options to view Assignments.
        </div>
    </div>

    <div *ngIf="!assignments?.length" class="heading">
        The Student has not been assigned any assignments.
    </div>

    <div fxLayout="row wrap" fxLayoutAlign="space-around center" fxLayoutGap="40px 75px grid" style="padding-bottom: 75px;">
        <div *ngFor="let assignment of filteredAssignments; trackBy: trackByFn">
            <assignment-card [assignment]="assignment" [classID] ="student?.ClassDetails.ClassID"></assignment-card>
        </div>
    </div>
  </div>

  <!-- Table legend describing cell color  -->
  <div *ngIf="studentDataReceived" fxLayout="row" fxLayoutAlign="space-around" class="color-indicator-container" fxLayoutGap="15px grid">
    <div *ngFor="let colorIndicator of colorIndicators" class="color-indicator">
      <span class="status-color" [ngStyle]="{'background-color': colorIndicator.color}">
      </span>
      <span class="status-label">
        {{ colorIndicator.label }}
      </span>
    </div>
  </div>

</div>
